const date = {
  mutations: {
    DATEFORMATE: (state, date) => { //时间格式化yy-mm-dd hh:mm:ss
      var sy = date.sj[0].getFullYear();
      var sm = date.sj[0].getMonth();
      var sd = date.sj[0].getDate();
      var sh = date.sj[0].getHours();
      var si = date.sj[0].getMinutes();
      var ss = date.sj[0].getSeconds();
      var ey = date.sj[1].getFullYear();
      var em = date.sj[1].getMonth();
      var ed = date.sj[1].getDate();
      var eh = date.sj[1].getHours();
      var ei = date.sj[1].getMinutes();
      var es = date.sj[1].getSeconds();
      date.startTime = sy + "-" + (sm + 1 < 10 ? '0' + (sm + 1) : sm + 1) + "-" + (sd < 10 ? '0' + sd : sd) + " " + (sh < 10 ? '0' + sh : sh) + ":" + (si < 10 ? '0' + si : si) + ":" + (ss < 10 ? '0' + ss : ss);
      date.endTime = ey + "-" + (em + 1 < 10 ? '0' + (em + 1) : em + 1) + "-" + (ed < 10 ? '0' + ed : ed) + " " + (eh < 10 ? '0' + eh : eh) + ":" + (ei < 10 ? '0' + ei : ei) + ":" + (es < 10 ? '0' + es : es);
      // console.log(date);
    },
    DATEFORMATETY: (state, date) => { //时间格式化通用yy-mm-dd hh:mm:ss
      var sy = date.sj[0].getFullYear();
      var sm = date.sj[0].getMonth();
      var sd = date.sj[0].getDate();
      var sh = date.sj[0].getHours();
      var si = date.sj[0].getMinutes();
      var ss = date.sj[0].getSeconds();
      var ey = date.sj[0].getFullYear();
      date.sj[1] = sy + "-" + (sm + 1 < 10 ? '0' + (sm + 1) : sm + 1) + "-" + (sd < 10 ? '0' + sd : sd) + " " + (sh < 10 ? '0' + sh : sh) + ":" + (si < 10 ? '0' + si : si) + ":" + (ss < 10 ? '0' + ss : ss);
      // console.log(date.setdate);
    },
    NEW_DATE: (state, date) => { //当天时间
      var nnewDate = new Date();
      var y = nnewDate.getFullYear();
      var m = nnewDate.getMonth();
      var d = nnewDate.getDate();
      var snewDate = new Date(y, m, d);
      date.sj = [snewDate, nnewDate];
      // console.log(date);
    },
       NEW_DATE_AllDay: (state, date) => { //当天时间
         var nnewDate = new Date();
      var y = nnewDate.getFullYear();
      var m = nnewDate.getMonth();
      var d = nnewDate.getDate();
      var d1 = nnewDate.getDate()+1;
      var snewDate = new Date(y, m, d);
       var tomorrow = new Date(y, m, d1);
      date.sj = [snewDate, tomorrow];
      // console.log(date);
    },
    DATE_AllDay: (state, date) => { //今天一天
  const snewDate = new Date(new Date(new Date().toLocaleDateString()).getTime());
  const tomorrow = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1);
   date.sj = [snewDate, tomorrow];
 },

    YESTODAY_DATE_AllDay: (state, date) => { //昨天时间
         var nnewDate = new Date();
      var y = nnewDate.getFullYear();
      var m = nnewDate.getMonth();
      var d = nnewDate.getDate()-1;
      var d1 = nnewDate.getDate();
      var snewDate = new Date(y, m, d);
       var tomorrow = new Date(y, m, d1);
      date.sj = [snewDate, tomorrow];
      // console.log(date);
    },
    YESTODAY_CURDATE_AllDay: (state, date) => { //昨天时间
         var nnewDate = new Date();
      var y = nnewDate.getFullYear();
      var m = nnewDate.getMonth();
      var d = nnewDate.getDate()-1;
      var snewDate = new Date(y, m, d);
      date.sj = [snewDate, snewDate];
      // console.log(date);
    },
    YESTODAY_DATE_OneDay: (state, date) => { //昨天时间 一天
      var nnewDate = new Date();
      var y = nnewDate.getFullYear();
      var m = nnewDate.getMonth();
      var d = nnewDate.getDate()-1;
      var tDate = new Date(y, m, d);
      date.sj = [tDate, tDate];
      // console.log(date);
    },
      YESTODAY_DATE_TOMORROW: (state, date) => { //昨天到明天
         var nnewDate = new Date();
      var y = nnewDate.getFullYear();
      var m = nnewDate.getMonth();
      var d = nnewDate.getDate()-1;
      var d1 = nnewDate.getDate()+1;
      var snewDate = new Date(y, m, d);
       var tomorrow = new Date(y, m, d1);
      date.sj = [snewDate, tomorrow];
      // console.log(date);
    },
    TODAY_DATE_WEEK: (state, date) => { //近7天
         var nnewDate = new Date();
      var y = nnewDate.getFullYear();
      var m = nnewDate.getMonth();
      var d = nnewDate.getDate()-7;
      var d1 = nnewDate.getDate();
      var snewDate = new Date(y, m, d);
       var week = new Date(y, m, d1);
      date.sj = [snewDate, week];
      // console.log(date);
    },
    TODAY_DATE_MONTH: (state, date) => { //近1个月
    var nnewDate = new Date();
   var y = nnewDate.getFullYear();
   var m = nnewDate.getMonth();
   var d = nnewDate.getDate()-30;
   var d1 = nnewDate.getDate();
   var snewDate = new Date(y, m, d);
    var week = new Date(y, m, d1);
   date.sj = [snewDate, week];
   // console.log(date);
 },
 CURRENT_MONTH: (state, date) => { //从6月1号开始
  var nnewDate = new Date();
 var y = nnewDate.getFullYear();
 var m = nnewDate.getMonth();
 var d = nnewDate.getDate()-30;
 var d1 = nnewDate.getDate();
 var snewDate;
 if (m>5) {
  snewDate = new Date(y, m, d)
 }else{
  snewDate=new Date('2019','5', '1');
 }
 var week = new Date(y, m, d1);
 date.sj = [snewDate, week];

},
    GETTREE: (state, data) => { //格式化树结构
      let items = { value: '', label: "", children: [] };
      let data1 = [];
      let splx = [];
      for (let i = 0; i < data.list.length; i++) {
        var aa1 = splx.find((item) => {
          return item === data.list[i].splx;
        });
        if (!aa1) {
          splx.push(data.list[i].splx);
          items = {
            value: data.list[i].id,
            label: data.list[i].splx,
            children: [
              { "value": data.list[i].id, "label": data.list[i].sppp, }
            ]
          }
          data1.push(items)
        } else {
          for (let n = 0; n < data1.length; n++) {
            // console.log(data1[n])
            if (data1[n].label == data.list[i].splx)
              data1[n].children.push({ value: data.list[i].id, label: data.list[i].sppp })
          }
        }
      }
      data.treedata = data1;
    }
  },

  actions: {
    timeFormat({ commit }, date) {
      commit('DATEFORMATE', date);
    },
    timeFormatty({ commit }, date) { //通用
      commit('DATEFORMATETY', date);
    },
    getNewDate({ commit }, date) { //当天时间-当前时间
      commit('NEW_DATE', date);
    },
    getAllDate({ commit }, date) { //00:00-23:59
      commit('DATE_AllDay', date);
    },
     getNewDateAllDay({ commit }, date) { //当天0点-明天0点
      commit('NEW_DATE_AllDay', date);
    },
    getTrees({ commit }, date) { //格式化树结构
      commit('GETTREE', date);
    },
    getYesterday({ commit }, date){
      commit('YESTODAY_DATE_AllDay', date);
    },
     getYesterdayCurDate({ commit }, date){
      commit('YESTODAY_CURDATE_AllDay', date);
    },
    getYestodays({ commit }, date){
      commit('YESTODAY_DATE_OneDay', date);
    },
    getYestodayToTomorrow({ commit }, date){
      commit('YESTODAY_DATE_TOMORROW', date);
    },
    getTodayToWeek({ commit }, date){
      commit('TODAY_DATE_WEEK', date);
    },
    getTodayToMonth({ commit }, date){
      commit('TODAY_DATE_MONTH', date);
    },
    getCurrentMonth({ commit }, date){
      commit('CURRENT_MONTH', date);
    }
  }

}

export default date



// WEBPACK FOOTER //
// ./src/store/modules/date.js